'use client'

import Link from 'next/link'

import { cn } from '@src/utils/tailwind'

export type SeeMore = {
  label: string
  url?: string
  onClick?: () => void
}

interface SeeMoreLinkProps extends SeeMore {
  className?: string
  dataTestId?: string
}

export function SeeMoreLink({ label, url, onClick, className, dataTestId }: SeeMoreLinkProps) {
  const base = 'text-body-base font-medium text-bodi-accent-bright-500 underline'

  if (url) {
    return (
      <Link className={cn('self-end', className)} href={url} data-testid={dataTestId}>
        <p className={base}>{label}</p>
      </Link>
    )
  }

  return (
    <button className={cn(base, 'self-end', className)} onClick={onClick} data-testid={dataTestId}>
      {label}
    </button>
  )
}
